<template>
	<div class="wrapper">
		<headerTag />
			<div v-if="firstPh">
				<p class="phoneNum">已验证手机：{{phone}}</p>
				<p class="userIn1" style="margin-bottom: 0;">
					<input type="password" placeholder="密码" maxlength="20" autocomplete="off" ref="authPwd"/>
					<img src="../../assets/images/user/password1.png" alt="" class="passwordImg" />
				</p>
				<button class="userBtn1" @click="authNext" :disabled="isDisable">下一步</button>
			</div>
			<div style="margin-top: 6.15rem;" v-if="setPh">
				<p class="userIn1">
					<input type="number" placeholder="新手机号" autocomplete="off" onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')"
			 					 oninput="if(value.length>11)value=value.slice(0,11)" ref="mobile" />
					<img src="../../assets/images/user/phone1.png" alt="" />
				</p>
				<p class="userIn1">
					<input type="text" placeholder="验证码" style="width: 68%;" maxlength="6" autocomplete="off"
			 					onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" ref="smscode"/>
					<button class="getCode" @click="sendSmsCode" id="getCode">获取验证码</button>
				</p>
				<button class="userBtn1" @click="updatePhone" :disabled="isDisable">完成</button>
			</div>
		<footerTag />
	</div>

</template>

<script>
    
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	import {VidateUtil} from '../../assets/js/validate.js' 
	import {sendSms,phoneSeconds} from '../../assets/js/smsUtil.js'
	import {Decrypt,Encrypt} from '../../assets/js/aes/cryptoUtil.js'
	import { Dialog,Toast } from 'vant'

	export default {
		name: 'phoneChange',
		props: {
			
		},
		data:function(){
			return {
				phone:'',
				isDisable:false,
				firstPh:true,
				setPh:false
			}
		},
		methods:{
			loadUserInfo(){
				this.axios({
				    method: 'POST',
				    url:'/user/userInfo',
				}).then((res)=>{
						if(res.data.code==1000){
							 let resultData = res.data.data.user;
							 this.phone = resultData.phone;
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
				  			this.$message.error({message: res.data.message});
				  		}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			authNext(){
				let pwd=this.$refs.authPwd.value;
				if (pwd == "" || pwd == null) {
					this.$message.error({message: '登录密码不能为空'});
					return;
				}
				if(!VidateUtil.checkPassword(pwd)){
					this.$message.error({message: '登录密码格式输入有误'});
					return;
				}
				//按钮不可点击
				this.isDisable=true; 
				this.axios({
					method: 'POST',
					url:'/user/modifyPhoneAuth',
					params:{
						password:pwd,
					},
				}).then((res)=>{
						this.isDisable=false; //按钮可点击
						if(res.data.code==1000){
							//成功
							this.firstPh=false; //隐藏
							this.setPh=true; //显示
						}else if(res.data.code==1002){
							this.$refs.authPwd.value=""; //置空
							this.$message.error({message: res.data.message});
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
					this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			updatePhone(){
				let mobile=this.$refs.mobile.value;
				let smscode=this.$refs.smscode.value;
				if (mobile == "" || mobile == null) {
					this.$message.error({message: '手机号不能为空'});
					return;
				}
				if(!VidateUtil.checkPhone(mobile)){
					this.$message.error({message: '手机号格式输入有误'});
					return;
				}
				if (smscode == "" || smscode == null) {
					this.$message.error({message: '验证码不能为空'});
					return;
				}
				if (smscode.length != 6) {
					this.$message.error({message: '验证码输入有误'});
					 return;
				}
				//按钮不可点击
				this.isDisable=true;
				this.axios({
					method: 'POST',
					url:'/user/modifyPhone',
					params:{
						mobile:Encrypt(mobile),
						smscode:smscode
					},
				}).then((res)=>{
						this.isDisable=false; //按钮可点击
						if(res.data.code==1000){
							//成功
							Dialog.alert({
							  message: '修改成功'
							}).then(() => {
							  this.$router.push({ name:'baseMessage' });
							});
						}else if(res.data.code==1002){
							//置空
							this.$refs.mobile.value=""; 
							this.$refs.smscode.value="";
							this.$message.error({message: res.data.message});
						}else{
							this.$message.error({message: res.data.message});
						}
				}).catch((err)=>{
					this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			sendSmsCode(){
				let mobilePhone=this.$refs.mobile.value;
				if (mobilePhone == "" || mobilePhone == null) {
					this.$message.error({message: '手机号不能为空'});
				    return;
				}
				var pattern = /^1[3456789]\d{9}$/;
				if (!pattern.test(mobilePhone)) {
					this.$message.error({message: '手机号格式有误'});
				    return;
				}
				if (mobilePhone.length != 11) {
					this.$message.error({message: '手机号格式有误'});
					return;
				}
				let mobile=Encrypt(mobilePhone);
				let _this=this;
				sendSms(5,mobile,function(data){
					if(data.code == 1000){
						//短信发送成功，弹出提示框
						_this.$toast("已发送验证码到您的手机，请注意查收");
						phoneSeconds(); //倒计时
					}else{
						_this.$message.error({message: data.message});
					}
				},(errorback)=>{
					//回调错误信息
					_this.$message.error({message: errorback});
				});
			}
		},
		components: {
			headerTag,
			footerTag,
			VidateUtil,
			sendSms,
			phoneSeconds,
			Dialog,
			Toast
		},
		created(){
			this.loadUserInfo();
		}
	}

</script>